var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExpandMore, LockOutlined } from '@mui/icons-material';
import { Box, useTheme } from '@mui/material';
export default function ExpandIcon() {
    var theme = useTheme();
    return (_jsxs(Box, __assign({ sx: {
            '.Mui-disabled & > .expandIconWrapper': {
                display: 'none',
            },
            '.disabledIconWrapper': {
                display: 'none',
            },
            '.Mui-disabled & > .disabledIconWrapper': {
                display: 'block',
            },
        } }, { children: [_jsx(Box, __assign({ sx: { display: 'flex' }, className: "expandIconWrapper" }, { children: _jsx(ExpandMore, { sx: { color: theme.palette.text.primary } }) })), _jsx("div", __assign({ className: "disabledIconWrapper" }, { children: _jsx(LockOutlined, {}) }))] })));
}
